export default theme => ({
	referentData: {
		alignContent: 'start',
		paddingTop: theme.spacing(2),
		border: '1px solid #ddd',
		borderRadius: 3,
		marginTop: theme.spacing(2)
	}
});
